<template>
    <x-layout class="field-group">
        <x-flex class="field-group__left">
            <h3 class="field-group__title">{{ title }}</h3>
        </x-flex>
        <x-flex class="field-group__content">
            <x-layout>
                <slot/>
            </x-layout>
        </x-flex>
    </x-layout>
</template>

<script>
    export default {
        name: "FieldGroup",
        props: ['title']
    }
</script>

<style lang="scss" scoped>

    .field-group__left {
        flex: 0 0 220px;
    }

    .field-group__title {
        color: #565E77;
        font-size: 14px;
        font-weight: 600;
        line-height: 2;
    }

    .field-group__content .layout .flex {
        padding-top: 0;
        padding-bottom: 0;
    }

    .field-group__content .layout .flex:first-child {
        padding-left: 0;
    }

    .field-group__content p:first-child {
        padding-top: 8px;
    }

    .field-group__content {
        line-height: 20px;
        color: #5B6786;
    }
</style>
